(() => {
  const dialog = document.getElementById('PeCheckoutOffer');
  const data = document.getElementById('PeCheckoutOfferData');
  if (!dialog || !data || window.peCheckoutOffer) return;
  window.peCheckoutOffer = true;
  const config = JSON.parse(data.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const list = dialog.querySelector('.pe-co-products');
  const submit = dialog.querySelector('.pe-co-submit');
  const close = dialog.querySelector('.pe-co-close');
  const error = dialog.querySelector('.pe-co-error');
  const descriptions = {
    'fijne-lijn-penselen': 'Voor fijne lijnen en kleine details.',
    'acryl-vernis': 'Een beschermende afwerking voor je schilderij.',
    'premium-houten-schildersezel': 'Geef je schilderij een stevige plek tijdens het schilderen.',
    'painting-expert-nummer-verwijderaar': 'Voor het bedekken van de nummers op je canvas.',
    'extra-verf': 'Extra verf bij je schilderpakket.',
    'professionele-atelierschort': 'Bescherm je kleding tijdens het schilderen.'
  };
  let cart, products = [], quantities = new Map(), variants = new Map(), busy = false, opening = false;
  const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat('nl-NL', {style:'currency', currency:cart?.currency || 'EUR'}).format(cents / 100);
  const getCart = async () => { const r = await fetch(root+'cart.js', {cache:'no-store'}); if(!r.ok) throw Error('Je winkelwagen kon niet worden geladen.'); return r.json(); };
  let checkingOut = false;
  const checkout = async () => {
    if (busy || checkingOut) return;
    checkingOut = true;
    let giftTimeout;
    try {
      if (window.peEnsurePrecisionBrushGift) {
        await Promise.race([
          window.peEnsurePrecisionBrushGift(),
          new Promise(resolve => { giftTimeout = setTimeout(resolve, 5000); })
        ]);
      }
    } catch (e) {
      // An optional gift must never block a customer's route to checkout.
      console.warn('Gift sync skipped before checkout:', e);
    } finally {
      clearTimeout(giftTimeout);
      location.assign(root+'checkout');
    }
  };
  const qty = p => quantities.get(p.id) || 0;
  const variant = p => p.variants.find(v => v.id === variants.get(p.id)) || p.variants[0];
  function availableProducts(current) {
    const ids = new Set(current.items.map(i => String(i.product_id)));
    const brushProducts = new Set(['10757710512465','10406363857233','10799295332689']);
    const hasBrushes = current.items.some(i => brushProducts.has(String(i.product_id)));
    return config.products.filter(p => !ids.has(String(p.id)) && !(hasBrushes && brushProducts.has(String(p.id))) && p.variants.length);
  }
  function render() {
    products = availableProducts(cart);
    list.innerHTML = products.map(p => `<article class="pe-co-card" data-id="${p.id}">
      <div class="pe-co-media"><img src="${esc(p.image)}" alt="" width="92" height="92" loading="lazy" decoding="async"><span class="pe-co-badge" hidden></span></div>
      <div><h4>${esc(p.title)}</h4><p class="pe-co-desc">${esc(descriptions[p.handle] || '')}</p>${p.variants.length>1 ? `<select aria-label="Uitvoering ${esc(p.title)}">${p.variants.map(v=>`<option value="${v.id}" ${variant(p).id===v.id?'selected':''}>${esc(v.title)}</option>`).join('')}</select>`:''}<div class="pe-co-price"></div></div>
      <div class="pe-co-qty"><button type="button" data-delta="-1" aria-label="Minder ${esc(p.title)}">−</button><output aria-label="Aantal ${esc(p.title)}">0</output><button type="button" class="pe-co-plus" data-delta="1" aria-label="Meer ${esc(p.title)}">+</button></div></article>`).join('');
    update();
  }
  function update() {
    let extra = 0, count = 0;
    products.forEach(p => {
      const n=qty(p), v=variant(p), card=list.querySelector(`[data-id="${p.id}"]`);
      extra += n*v.price; count += n;
      card.classList.toggle('is-selected', n>0);
      card.querySelector('output').textContent=n;
      card.querySelector('[data-delta="-1"]').disabled=n===0;
      card.querySelector('[data-delta="1"]').disabled=n>=10;
      card.querySelector('.pe-co-price').innerHTML=esc(money(v.price))+(v.compare>v.price?`<s>${esc(money(v.compare))}</s>`:'');
      const badge=card.querySelector('.pe-co-badge');badge.hidden=!(v.compare>v.price);badge.textContent=v.compare>v.price?`−${Math.round((1-v.price/v.compare)*100)}%`:'';
    });
    const total=cart.total_price+extra, threshold=config.giftThreshold;
    dialog.querySelector('.pe-co-total strong').textContent=money(total);
    dialog.querySelector('.pe-co-shipping').textContent=total>threshold ? 'Je krijgt een gratis mysterycadeau bij je bestelling!' : total===threshold ? 'Boven €100 ontvang je een gratis mysterycadeau.' : `Nog ${money(threshold-total)} tot €100 — boven €100 krijg je een gratis mysterycadeau!`;
    dialog.querySelector('progress').value=threshold>0?Math.min(100,total/threshold*100):100;
    submit.textContent=count?'Toevoegen & afrekenen':'Verder zonder toevoegen';submit.classList.toggle('has-items',count>0);
  }
  let catalogPromise;
  async function loadCatalog() {
    if (!config.catalogSection) return;
    if (!catalogPromise) catalogPromise = fetch(root+'?section_id='+encodeURIComponent(config.catalogSection), {cache:'no-store'})
      .then(async r => {if(!r.ok) throw Error('Accessoires konden niet worden geladen.');const doc=new DOMParser().parseFromString(await r.text(),'text/html');const el=doc.querySelector('#PeCheckoutCatalog');if(!el)throw Error('Accessoires ontbreken.');config.products=JSON.parse(el.textContent).products;})
      .catch(e=>{catalogPromise=null;throw e;});
    return catalogPromise;
  }
  async function open() {
    if (opening || busy || dialog.open) return;
    opening=true;error.hidden=true;quantities.clear();variants.clear();
    try {
      const loaded=await Promise.all([getCart(),loadCatalog()]);cart=loaded[0];
      if(!cart.item_count || !availableProducts(cart).length) {checkout();return;}
      render();dialog.showModal();close.focus();
    } catch (_) {checkout();} finally {opening=false;}
  }
  function eligible(element) {
    if(!element || element.disabled || element.getAttribute('aria-disabled')==='true')return false;
    if(element.closest('.cart__buttons--disabled'))return false;
    const form=element.form || element.closest('form');
    return !form || form.reportValidity();
  }
  document.addEventListener('click', e => {
    const button=e.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href$="/checkout"]');
    if (!button || dialog.contains(button) || !eligible(button) || e.ctrlKey || e.metaKey || e.shiftKey) return;
    e.preventDefault();e.stopImmediatePropagation();open();
  }, true);
  document.addEventListener('submit', e => {
    if(e.submitter?.name !== 'checkout' || !eligible(e.submitter))return;
    e.preventDefault();e.stopImmediatePropagation();open();
  }, true);
  list.addEventListener('click', e => {
    const b=e.target.closest('[data-delta]');if(!b || b.disabled || busy)return;
    const id=Number(b.closest('[data-id]').dataset.id);
    quantities.set(id,Math.max(0,Math.min(10,(quantities.get(id)||0)+Number(b.dataset.delta))));update();
  });
  list.addEventListener('change', e=>{if(busy || !e.target.matches('select'))return;variants.set(Number(e.target.closest('[data-id]').dataset.id),Number(e.target.value));update();});
  close.addEventListener('click',checkout);
  dialog.addEventListener('cancel', e=>{e.preventDefault();checkout();});
  submit.addEventListener('click',async()=>{
    if(busy)return;
    if(!products.some(p=>qty(p)>0)){checkout();return;}
    busy=true;submit.disabled=true;close.disabled=true;list.inert=true;error.hidden=true;submit.textContent='Even toevoegen…';
    try {
      const fresh=await getCart();
      const allowed=new Set(availableProducts(fresh).map(p=>p.id));
      const items=products.filter(p=>qty(p)>0&&allowed.has(p.id)).map(p=>({id:variant(p).id,quantity:qty(p)}));
      if(items.length){
        const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        if(!r.ok){const body=await r.json();throw Error(typeof body.description==='string'?body.description:'Toevoegen is niet gelukt. Controleer je keuze.');}
      }
      busy=false;checkout();
    }catch(e){
      // Re-read before any retry: Shopify may have processed a request whose response was lost.
      try{cart=await getCart();render();}catch(_){}
      error.textContent=e.message || 'Toevoegen is niet gelukt. Probeer opnieuw of ga verder zonder toevoegen.';error.hidden=false;
    }finally{busy=false;submit.disabled=false;close.disabled=false;list.inert=false;update();}
  });
})();
